import { NgModule } from '@angular/core';
import { RouterModule, Routes }  from '@angular/router';

import { OfferListPageComponent } from './containers/offer-list-page/offer-list-page.component';
import { OfferPreviewPageComponent } from './containers/offer-preview-page/offer-preview-page.component';
import { OfferMetricsPageComponent } from './containers/offer-metrics-page/offer-metrics-page.component';

import { AuthGuard } from '../auth/guards/auth.guard';

const routes: Routes = [
  {
    path: 'offers',
    canActivate: [ AuthGuard ],
    children: [
      {
        path: 'history',
        component: OfferListPageComponent,
        data: {
          history: true
        }
      },
      {
        path: '',
        pathMatch: 'full',
        component: OfferListPageComponent,
      },
      {
        path: 'metrics/:id',
        component: OfferMetricsPageComponent,
      },
      {
        path: ':id',
        component: OfferPreviewPageComponent,
      },
      // {
      //   path: 'selection',
      //   component: OfferSelectionPageComponent,
      // },
      // {
      //   path: 'recipients',
      //   component: OfferRecipientsPageComponent,
      // },
      // {
      //   path: 'new',
      //   component: OfferFormPageComponent,
      //   canDeactivate: [ LeaveDirtyFormGuard ],
      // },
      // // Generic Coupons
      // {
      //   path: 'coupons/generic/new',
      //   component: OfferCouponGenericFormPageComponent,
      //   canDeactivate: [ LeaveDirtyFormGuard ],
      // },
      // {
      //   path: 'coupons/generic/:id',
      //   component: OfferCouponGenericFormPageComponent,
      //   canDeactivate: [ LeaveDirtyFormGuard ],
      // },
      // // Unique coupons
      // {
      //   path: 'coupons/unique/new',
      //   component: OfferCouponUniqueFormPageComponent,
      //   canDeactivate: [ LeaveDirtyFormGuard ],
      // },
      // {
      //   path: 'coupons/unique/:id',
      //   component: OfferCouponUniqueFormPageComponent,
      //   canDeactivate: [ LeaveDirtyFormGuard ],
      // },
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class OfferRoutingModule {}
